/* eslint-disable class-methods-use-this */
/* eslint-disable no-magic-numbers */
import Phase from '../phase-core/Phase';

const { max, cos, pow, PI } = Math;
const PIH = PI / 2;

export default class Flash extends Phase.Config {
	run({ bg_opts, time }) {
		bg_opts.flash = max(0, pow(cos(time.offBeat * PIH), 10) * 3 - 2);
	}
}
